<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.add_registration || 'Student Registration' }}</h2>
        </div>
        <div class="header-action">
          <!-- <button class="btn-add" data-bs-toggle="offcanvas" data-bs-target="#branch">
            <i class="bi bi-plus"></i>
          </button> -->

             <button class="btn-add" @click="add_new_staff()">
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- CSV Upload Section -->
      <!--<div class="csv-section">-->
      <!--  <div class="section-header">-->
      <!--    <h3>Bulk Import</h3>-->
      <!--  </div>-->
      <!--  <div class="csv-card">-->
      <!--    <div class="csv-content">-->
      <!--      <div class="csv-icon">-->
      <!--        <i class="bi bi-file-earmark-spreadsheet"></i>-->
      <!--      </div>-->
      <!--      <div class="csv-info">-->
      <!--        <h4>Upload CSV File</h4>-->
      <!--        <p>Import multiple students at once</p>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div class="csv-action">-->
      <!--      <label for="csv-upload" class="btn-csv">-->
      <!--        <i class="bi bi-cloud-upload"></i>-->
      <!--        Upload CSV-->
      <!--      </label>-->
      <!--      <input -->
      <!--        id="csv-upload" -->
      <!--        type="file" -->
      <!--        @change="handleFileUpload" -->
      <!--        accept=".csv" -->
      <!--        hidden-->
      <!--      />-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->

      <!-- Student List Section -->




      <div class="student-section">
  <!-- <div class="section-header">
    <h3>Student List</h3>
    <p class="student-count">{{ studentlist.length }} students</p>
  </div> -->

  <!-- Empty State -->
  <div v-if="studentlist.length === 0" class="empty-state">
    <div class="empty-icon">
      <i class="bi bi-person-plus"></i>
    </div>
    <h3>No Students Found</h3>
    <p>Add students to get started</p>
  </div>

  <!-- Student Table -->
  <div v-else class="table-responsive">
    <table class="table table-bordered"  id="datatable">
      <thead class="table-light">
        <tr>
          <th>#</th>
          <th>Entry Date</th>
          <th>Student Name</th>
          <th>Exam</th>
          <th>Mobile</th>
          <th>PRN</th>
          <th>Status</th>
          <th style="width:120px">Action</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, i) in studentlist" :key="item.id">
          <td>{{ i + 1 }}</td>
          <td>{{ item.student_entry_date }}</td>
          <td>{{ item.student_name }}</td>
          <td>{{ item.exam_name }}</td>
          <td>{{ item.mobile }}</td>
          <td>{{ item.student_prn }}</td>
          <td>
        
              {{ item.admission_status }}
           
          </td>
          <td class="d-flex gap-1">

             <button class="btn p-1  btn-success " @click="ViewStudent(item.id)">
              <i class="bi bi-eye  font-sm"></i>
            </button>


            <button class="btn p-1  btn-primary  " @click="editStudent(item)">
              <i class="bi bi-pencil  font-sm"></i>
            </button>
            <button class="btn p-1 btn-danger" @click="deleteAddStudentRegistration(item.id)">
              <i class="bi bi-trash  font-sm"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>













   
    </main>







<div class="modal fade show d-block" tabindex="-1" v-if="showmodal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Student Registration</h5>
        <button type="button" class="btn-close" @click="showmodal = false"></button>
      </div>

      <div class="modal-body">
        <form  @submit.prevent="AddStudentRegistration">

          <div class="row">


       <div class="col-12">
                <label  class="form-label" for="img_upload_here">{{language?.Image || 'Student Photo'}}<br>
                <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
                <!-- <img src="../assets/upload_image.jpg" style="             height: 50px; "/> -->
                <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                </label>
            </div>

              <!-- विषय -->
            <!-- <div class="col-6 col-md-3 mb-3">
              <label>विषय</label>
              <input type="text" class="form-control" v-model="studentregistration.subject" required="">
            </div> -->

      <div class="col-6  col-md-3 mb-3">
              <label for="subject" class="form-label">विषय</label>
              <select class="form-select form-select-sm" id="subject" v-model="studentregistration.subjectid"  @change="syncSubject">
                <option value="">निवडा</option>
                <option v-for="(item, index) in subjectlist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>


            <!-- विभाग -->
                  <div class="col-6 col-md-3 mb-3">
                    <label>विभाग</label>
                    <input type="text" class="form-control" v-model="studentregistration.department" required>
                  </div>

                  <!-- शाखा -->
                  <div class="col-6 col-md-3 mb-3">
                    <label>शाखा</label>
                    <input type="text" class="form-control" v-model="studentregistration.branch">
                  </div>



            <!-- विद्यार्थी संपूर्ण नाव -->
            <div class="col-12 col-md-3 mb-3">
              <label>विद्यार्थी संपूर्ण नाव</label>
              <input type="text" class="form-control" v-model="studentregistration.student_name" required>
            </div>

            <!-- जन्मतारीख -->
            <div class="col-6  col-md-4 mb-3">
              <label>जन्मतारीख</label>
              <input type="date" class="form-control" v-model="studentregistration.dob">
            </div>

            <!-- मोबाईल -->
            <div class="col-6 col-md-4 mb-3">
              <label>मोबाईल</label>
              <input type="number" class="form-control" v-model="studentregistration.mobile" required>
            </div>

            <!-- Email -->
            <div class="col-6  col-md-4 mb-3">
              <label>Email</label>
              <input type="email" class="form-control" v-model="studentregistration.email">
            </div>

             <div class="col-6 col-md-3 mb-3">
              <label> शालेय शिक्षण </label>
              <input type="text" class="form-control" v-model="studentregistration.shalay_shikshan">
            </div>

            <!-- धर्म -->
            <div class="col-6 col-md-3 mb-3">
              <label>धर्म</label>
              <input type="text" class="form-control" v-model="studentregistration.religion">
            </div>

              <!-- जात -->
            <div class="col-6 col-md-3 mb-3">
              <label>जात</label>
              <input type="text" class="form-control" v-model="studentregistration.caste">
            </div>

             <div class="col-6 col-md-3 mb-3">
              <label>आधार नं.</label>
              <input type="number" class="form-control" v-model="studentregistration.aadhar_number" required>
            </div>

            <!-- पालकाचे नाव -->
            <div class="col-6 col-md-3 mb-3">
              <label>वडिलांचे संपूर्ण नाव</label>
              <input type="text" class="form-control" v-model="studentregistration.father_name" required>
            </div>

            <div class="col-6 col-md-3 mb-3">
              <label>व्यवसाय</label>
              <input type="text" class="form-control" v-model="studentregistration.occupation">
            </div>

             <!-- WhatsApp Number -->
            <div class="col-6 mb-3">
              <label>WhatsApp Number</label>
              <input type="number" class="form-control" v-model="studentregistration.whatsapp">
            </div>
            
            <!-- इतर संपर्क -->
            <div class="col-6  col-md-3 mb-3">
              <label>इतर संपर्क</label>
              <input type="number" class="form-control" v-model="studentregistration.other_contact">
            </div>

          <!-- आईचे नाव -->
            <div class="col-6  col-md-3 mb-3">
              <label>आईचे नाव</label>
              <input type="text" class="form-control" v-model="studentregistration.mother_name">
            </div>
            
          <!-- संपर्क -->
            <div class="col-6  col-md-3 mb-3">
              <label>संपर्क</label>
              <input type="number" class="form-control" v-model="studentregistration.contact">
            </div>

              <div class="col-6  col-md-3 mb-3">
              <label>कार्य</label>
              <input type="text" class="form-control" v-model="studentregistration.kary">
            </div>

               <!-- पत्ता -->
            <div class="col-12  col-md-6  mb-3">
              <label>पत्ता</label>
              <textarea class="form-control" v-model="studentregistration.address"></textarea>
            </div>
                 <div class="col-12 col-md-6 mb-3">
              <label>कायमचा पत्ता</label>
              <textarea class="form-control" v-model="studentregistration.permanant_address"></textarea>
            </div>

        <!-- निवडलेला विषय -->
            <div class="col-6  col-md-3 mb-3">
              <label>निवडलेला विषय</label>
              <input type="text" class="form-control" v-model="studentregistration.selected_subject">
            </div>

        <!-- परीक्षा -->
            <!-- <div class="col-6  col-md-3 mb-3">
              <label>परीक्षा</label>
              <input type="text" class="form-control" v-model="studentregistration.exam" required>
            </div> -->

            <div class="col-6  col-md-3 mb-3">
              <label for="exam" class="form-label">परीक्षा</label>
              <select class="form-select form-select-sm" id="exam" v-model="studentregistration.addexamid">
                <option value="">निवडा</option>
                <option v-for="(item, index) in examlist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

    <!-- प्रवेश तारीख -->
            <div class="col-6  col-md-3 mb-3">
              <label>प्रवेश तारीख</label>
              <input type="date" class="form-control" v-model="studentregistration.admission_date">
            </div>

            <div class="col-6  col-md-3 mb-3">
              <label>फी जमा करण्याचा प्रकार</label>
              <select class="form-select" v-model="studentregistration.fee_details">
                <option value="">निवडा</option>
                <option value="वार्षिक">वार्षिक</option>
                <option value="सहामाही">सहामाही</option>
                <option value="त्रैमासिक">त्रैमासिक</option>
                <option value="मासिक">मासिक</option>
              </select>
            </div>


        <div class="col-12 mb-3">
              <label>या विद्यालयाची माहिती आपणास कोठून मिळाली</label>
              <input type="text" class="form-control" v-model="studentregistration.information_source">
            </div>


            <h2 class="text-center">कार्यालयीन</h2>


          <div class="col-12 mb-3">
              <label>विद्यार्थी नाव</label>
              <input type="text" class="form-control" v-model="studentregistration.student_name">
            </div>

             <div class="col-6  col-md-3 mb-3">
              <label>PRN</label>
              <input type="text" class="form-control" v-model="studentregistration.student_prn">
            </div>

              <!-- <div class="col-6  col-md-3 mb-3">
              <label>विषय</label>
              <input type="text" class="form-control" v-model="studentregistration.student_subject">
            </div> -->

                  <div class="col-6  col-md-3 mb-3">
              <label for="subject2" class="form-label">विषय</label>
              <select class="form-select form-select-sm" id="subject2" v-model="studentregistration.student_subject">
                <option value="">निवडा</option>
                <option v-for="(item, index) in subjectlist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

             <div class="col-6  col-md-3 mb-3">
              <label>विभाग</label>
              <input type="text" class="form-control" v-model="studentregistration.student_vibhag">
            </div>

                <div class="col-6  col-md-3 mb-3">
                <label>यांचा प्रवेश मंजूर / नामंजूर केला असे.</label>
                <select class="form-select" v-model="studentregistration.admission_status">
                  <option value="">निवडा</option>
                  <option value="मंजूर">मंजूर</option>
                  <option value="नामंजूर">नामंजूर</option>
                </select>
              </div>

              <div class="col-6  col-md-3 mb-3">
              <label>दिनांक </label>
              <input type="date" class="form-control" v-model="studentregistration.student_entry_date">
            </div>

            <h2 class="text-center">शुल्क जमा</h2>


      <div class="col-6 col-md-6 mb-3">
            <label>एकूण रक्कम</label>
            <input type="number" class="form-control" v-model="studentregistration.total_amount">
          </div>

          <div class="col-6 col-md-6 mb-3">
            <label>जमा रक्कम</label>
            <input type="number" class="form-control" v-model="studentregistration.paid_amount">
          </div>













 
          </div>

          <!-- Actions -->
          <div class="text-end mt-3">
            <button type="submit" class="btn btn-primary">Save</button>
            <button type="button" class="btn btn-secondary" @click="showmodal=false">Cancel</button>
          </div>

        </form>
      </div>

    </div>
  </div>
</div>


<!-- Backdrop -->
<div v-if="showmodal" class="modal-backdrop fade show"></div>















  </div>
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  mounted() { 
    if(this.$route.query.id){
      this.getBranches(this.$route.query.id);
    } else {
      this.getBranches();
    }
  
  },
  data() {
   const todayDate = new Date().toISOString().slice(0, 10);
    return { 
      imagePreview:false,
      loading: false,
      showmodal: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      language: this.getLocalStorageArray('lang'),


   studentregistration: {
      subject: '',
      department: '',
      branch: '',
      student_name: '',
      dob: todayDate,
      mobile: '',
      email: '',
      shalay_shikshan: '',
      religion: '',
      caste: '',
      aadhar_number: '',
      father_name: '',
      occupation: '',
      whatsapp: '',
      other_contact: '',
      mother_name: '',
      contact: '',
      kary: '',
      address: '',
      permanant_address:'',
      selected_subject: '',
      exam: '',
      admission_date: todayDate,
      fee_details: '',
      information_source: '',
      student_prn: '',
      student_subject: '',
      student_vibhag: '',
      admission_status: '',   
      student_entry_date: todayDate,
      examid:'',
      total_amount:'',
      paid_amount:'',
    },





      examlist:[],
      subjectlist:[],
      studentlist: [], 
      classList: [],
      branch_name: '',
    }
  },
  methods: {
   

        add_new_staff() {
     this.subject= {
        name: '',
        status: 1,
        code: '',
        description: '',
      };



      this.showmodal=true;

    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    goprevious() {
      this.$router.push("/branch");
    },

    async getBranches(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getStudentRegistration", { id: id }).then((response) => {
          self.studentlist = response.data.studentlist;
          self.examlist = response.data.examlist;
          self.subjectlist = response.data.subjectlist;
          self.language = response.data.language;

          self.studentregistration.examid = id;
          localStorage.setItem('lang', response.data.language);
        }).then(() => {
        


          $("#subject").select2({
                        width: '250px', 
                        placeholder:"Search Subject Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
               
                             
                            self.studentregistration.subjectid =  event.target.value;
                             
                            
                        });


                        
          $("#exam").select2({
                        width: '250px', 
                        placeholder:"Search Exam Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                        
                             
                          self.tudentregistration.examid =  event.target.value;
                             
                            
                        });



      $("#subject2").select2({
                              width: '250px', 
                              placeholder:"Search Subject Here...",
                          "language": {
                                      "noResults": function(){
                                          return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                      }
                                  },
                                      escapeMarkup: function (markup) {
                                          return markup;
                                      }
                          }).on('change', function (event) {
                    
                                  
                                  self.studentregistration.student_subject =  event.target.value;
                                  
                                  
                              });









                               self.initializeHomeContent();







        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    AddStudentRegistration() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        if (self.studentregistration.department == '') {
          self.$swal.fire("Department is Required!");
        } else {

    alert("save");
          axios.post("StudentRegistration", self.studentregistration,

                 {
                headers: {
                  'Content-Type': 'multipart/form-data' 
              }}


          ).then((response) => {
            self.studentlist = response.data.studentlist;
            self.$swal.fire(response.data.message);
            
            if (response.data.success) {


                    self.showmodal = false;


              // Reset form



              self.studentregistration = {
                      subject: '',
                      department: '',
                      branch: '',
                      student_name: '',
                      dob: todayDate,
                      mobile: '',
                      email: '',
                      shalay_shikshan: '',
                      religion: '',
                      caste: '',
                      aadhar_number: '',
                      father_name: '',
                      occupation: '',
                      whatsapp: '',
                      other_contact: '',
                      mother_name: '',
                      contact: '',
                      kary: '',
                      address: '',
                      selected_subject: '',
                      exam: '',
                      admission_date: todayDate,
                      fee_details: '',
                      information_source: '',
                      student_prn: '',
                      student_subject: '',
                      student_vibhag: '',
                      admission_status: '',  
                      student_entry_date: todayDate,
                      student_img:'', 
               
              };


        
            }
          }).then(() => {
          
          }).catch((err) => {
            console.error(err);
          });
        }
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    editStudent(student) {
      this.studentregistration = {...student};
      this.showmodal = true;
    }, 

    deleteAddStudentRegistration(id = "") {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        this.$swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post("deleteAddStudentRegistration", { id: id }).then((response) => {
              self.studentlist = response.data.studentlist;
              self.$swal.fire(response.data.message);
            }).then(() => {
              self.initializeHomeContent();
            }).catch((err) => {
              self.$swal.fire("Error!", "Something went wrong.", "error");
            });
          }
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },

    async handleFileUpload(e) {
      var self = this;
      const file = e.target.files[0];
      if (!file) return;
      
      const formData = new FormData();
      formData.append("csv_file", file);

      try {
        const response = await axios.post("importcsvclient", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        self.studentlist = response.data.studentlist || self.studentlist;
        self.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.msg || 'CSV imported successfully'
        });
        this.getBranches(this.$route.query.id); // Refresh the list
      } catch (error) {
        console.error("Upload Failed:", error);
        self.$swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: error.response?.data?.msg || 'Failed to import CSV'
        });
      }
    },



    ViewStudent(id) {
      this.$router.push({ name: 'printpreview', query: { id: id } });
    },


    
        eventFileUpload(event) {
                this.studentregistration.student_img = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.studentregistration.student_img = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },

            syncSubject() {
    this.studentregistration.student_subject =
      this.studentregistration.subjectid;
  },


   initializeHomeContent() {
                      this.$nextTick(() => {
                        const table = $("#datatable");
                    
                        if ($.fn.DataTable.isDataTable(table)) {
                          table.DataTable().destroy();
                        }
                    
                        table.DataTable({
                          pageLength: 10,
                          searching: true,
                          ordering: true
                        });
                      });
                    },  


            destroyDataTable() {
              if ($.fn.DataTable.isDataTable("#datatable")) {
                $("#datatable").DataTable().destroy();
              }
            },











  }
}
</script>

<style scoped>
.text-sm{
    font-size: 14px;
}
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.student-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.student-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.student-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.student-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.student-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.student-info {
  flex: 1;
}

.student-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.student-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.student-number {
  font-size: 12px;
  color: #7f8c8d;
  background: #f5f7fa;
  padding: 4px 8px;
  border-radius: 8px;
}

.student-details {
  margin-bottom: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
}

.student-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.student-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
    width: 100%;
    padding: 2px 5px;
    border: 1px solid #1d1d1d;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .student-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .student-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
</style>